import styled, { keyframes } from 'styled-components';
import { motion } from '../../styles/motion';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Bone = styled.div<{
  $width?: string;
  $height?: string;
  $radius?: string;
}>`
  width: ${(p) => p.$width || '100%'};
  height: ${(p) => p.$height || '14px'};
  border-radius: ${(p) => p.$radius || '6px'};
  background: linear-gradient(90deg, #e8ecef 25%, #f4f6f8 50%, #e8ecef 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: #e8ecef;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const PageBlock = styled.div`
  width: 100%;
  padding: 8px 0;
  animation: pageFade ${motion.durationEnter} ${motion.easing};

  @keyframes pageFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
